import React from 'react';
import RenderError from '../../components/RenderError';

function AdditionalBasicInfoFields({
  two,
  unit,
  handleInputChange,
  equipmentType,
  formData,
  errors
}) {
  return (
    <>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor="typeOfWeedControl"
        >
          What type of propane-fueled flame weed control system did you purchase
          through the Propane Farm Research Program?
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].typeOfWeedControl}
          />
        )}
        {[
          'Tractor Pulled Flame Weed Control System',
          'Push Type Flame Weed Control Cart'
        ].map((value) => (
          <label className="form__radio" key={value}>
            <input
              type="radio"
              name={`typeOfWeedControl${two ? '2' : '1'}`}
              value={value}
              checked={
                two
                  ? formData.unitTwo.typeOfWeedControl2 === value
                    ? 'checked'
                    : ''
                  : formData.unitOne.typeOfWeedControl1 === value
                  ? 'checked'
                  : ''
              }
              onChange={(event) => handleInputChange(event, two)}
            />
            {value}
          </label>
        ))}
      </div>

      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20">
          Please share the following details:
        </label>
        <p className="u--margin-bottom-10 u--margin-top-10">Number of rows: </p>
        <input
          type="number"
          name="numberOfRows"
          value={formData[unit].numberOfRows}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].numberOfRows}
          />
        )}
        <p className="u--margin-bottom-10 u--margin-top-10">
          Number of torches/burners:{' '}
        </p>
        <input
          type="number"
          name="numberOfBurners"
          value={formData[unit].numberOfBurners}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].numberOfBurners}
          />
        )}
      </div>
    </>
  );
}

export default AdditionalBasicInfoFields;
